import { enumElementBorderStyle, enumFillMode } from "../constants";
import { QElement } from "./QElement";

export class QCustomExcelBorder extends QElement {
  constructor() {
    super();
  }

  InitBorderElement(parentPanel, x, y, width, height) {
    this.SizeElement(width, height);
    this.PositionElement(x, y);
    parentPanel.PushElement(this);

    this.SetFillMode(enumFillMode.solidFill);
    this.SetFillColor("#FFFFFF");
    this.SetBorderStyle(enumElementBorderStyle.singleBorder);
    this.SetBorderThickness(1);
    this.SetBorderColor("#000000");
  }
}
